"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../../composite/table/table-cells");
const table_filter_cells_1 = require("../../../composite/table/table-filter-cells");
const export_api_1 = require("../export-api");
function useColumns() {
    const intl = react_intl_1.useIntl();
    return [
        {
            datakey: 'state',
            sortkey: 'state.name',
            filterkey: 'state.id',
            name: intl.formatMessage({
                id: 'EAS_EXPORT_REQUESTS_COLUMN_STATE',
                defaultMessage: 'Stav',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(export_api_1.useExportRequestStates),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(export_api_1.useExportRequestStates),
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'type',
            sortkey: 'type.name',
            filterkey: 'type.id',
            name: intl.formatMessage({
                id: 'EAS_EXPORT_REQUESTS_COLUMN_TYPE',
                defaultMessage: 'Typ výstupu',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(export_api_1.useExportTypes),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(export_api_1.useExportTypes),
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'processingStart',
            name: intl.formatMessage({
                id: 'EAS_EXPORT_REQUESTS_COLUMN_PROCESSING_START',
                defaultMessage: 'Začátek zpracování',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.DateTimeCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'processingEnd',
            name: intl.formatMessage({
                id: 'EAS_EXPORT_REQUESTS_COLUMN_PROCESSING_END',
                defaultMessage: 'Konec zpracování',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.DateTimeCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'systemRequest',
            name: intl.formatMessage({
                id: 'EAS_EXPORT_REQUESTS_COLUMN_SYSTEM_REQUEST',
                defaultMessage: 'Systémový',
            }),
            width: 120,
            CellComponent: table_cells_1.TableCells.BooleanCell,
            sortable: true,
            filterable: true,
        },
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=export-requests-colums.js.map